import * as React from "react";
import { includes } from "lodash";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { BaseComponent } from "../../../../../../../react-core/Html/BaseComponent";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { SwitchAction } from "../../../Switch/Action/SwitchAction";

interface ICommissionChargeMessageProps {
    processType: ProcessType;
    cancelAll?: boolean;
    message?: string;
    hierachyid?: string;
}

interface ICommissionChargeMessageState {
    rate: number | null;
    Discretionary: boolean;
}

export class CommissionChargeMessage extends BaseComponent<
    ICommissionChargeMessageProps,
    ICommissionChargeMessageState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            rate: null,
            Discretionary: true,
        };
    }

    componentDidMount() {
        SwitchAction.checkFBRC(getQueryParameters()["subaccounthierarchyid"], (val) => {
            this.setState({ rate: val?.Rate, Discretionary: val?.Discretionary });
        });
    }

    private getProccessType(): ProcessType {
        return this.props.processType;
    }

    private hasFBRC(): boolean {
        return !CommonHelper.isNullOrEmpty(this.state.rate);
    }

    private shouldDisplayMessageForFbrcOff() {
        const processType: ProcessType = this.getProccessType();
        const hasSelfFBRC = this.hasFBRC();
        if (
            includes([ProcessType.SinglePayment, ProcessType.AddRegular, ProcessType.EditRegular], processType) &&
            (this.props.cancelAll || hasSelfFBRC)
        ) {
            return true;
        }

        if (includes([ProcessType.Buy, ProcessType.Sell, ProcessType.Switch], processType) && hasSelfFBRC) {
            return !this.state.Discretionary;
        }

        return false;
    }

    private shouldDisplayMessage() {
        return this.shouldDisplayMessageForFbrcOff();
    }

    public renderMessage() {
        return <Alert alertType={AlertType.Warning} message={this.props.message} />;
    }

    public render(): JSX.Element {
        const isShow = this.shouldDisplayMessage();
        if (!isShow) {return null;}
        return this.renderMessage();
    }
}
